import React, { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./ResetPasswordOTP.scss";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../../i18n/i18n";
import { svgs } from "../../common/assats";
import { useTranslation } from "react-i18next";
import { forgetPassword, postResetOtp } from "../../common/api/apiCalls";
import { useAlert } from "../../common/contexts/AlertContext";
import { useUser } from "../../common/contexts/UserContext";
import OtpInput from "react-otp-input";

const OTP_LENGTH = 6;
const RESEND_INTERVAL = 60;
const ResetPasswordOTP = () => {
  const alert = useAlert();
  const SIGN_IN_TEXT_MAIN_TITLE = i18n.t(
    "ResetPassword.SIGN_IN_TEXT_MAIN_TITLE"
  );
  const SIGN_IN_TEXT_SUB_TITLE = i18n.t("ResetPassword.SIGN_IN_TEXT_SUB_TITLE");
  const SIGN_IN_TEXT_INPUT_1_PLACEHOLDER = i18n.t(
    "ResetPassword.SIGN_IN_TEXT_INPUT_1_PLACEHOLDER"
  );
  const SIGN_IN_TEXT_INPUT_2_PLACEHOLDER = i18n.t(
    "ResetPassword.SIGN_IN_TEXT_INPUT_2_PLACEHOLDER"
  );
  const SIGN_IN_TEXT_BUTTON_1 = i18n.t("ResetPassword.SIGN_IN_TEXT_BUTTON_1");
  const SIGN_IN_TEXT_BUTTON_2 = i18n.t("ResetPassword.SIGN_IN_TEXT_BUTTON_2");
  const SIGN_IN_TEXT_LABEL_1 = i18n.t("ResetPassword.SIGN_IN_TEXT_LABEL_1");

  // const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
  const [otp, setOtp] = useState<any>("");
  const [timer, setTimer] = useState<number>(30);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const { t } = useTranslation();
  const getText = (text: string) => t(`forgetPassword.${text}`);
  const navigate = useNavigate();
  const location = useLocation();
  const { email, otpType } = location.state || { email: "" };
  const { user, fetchUser } = useUser();

  const handleChange = (index: number, value: string) => {
    if (isNaN(Number(value))) return; // Only allow numbers
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Move to the next field if a value is entered
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    // Move to the previous input on Backspace if current is empty
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleVerify = async () => {
    const enteredOtp = otp;
    console.log("Entered OTP:", enteredOtp);

    if (enteredOtp.length !== 6) {
      alert(getText("Please_enter_all_6_digits_of_the_OTP"), "error");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await postResetOtp(enteredOtp);
      if (response.success) {
        if (otpType === "adminOtp") {
          await fetchUser();
          navigate("/Home/Dashboard", { replace: true });
          return;
        }
        navigate("/Register/SetNewPassword", { replace: true });
      } else {
        setError("Invalid OTP, please try again.");
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      setError("An error occurred while verifying the OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setTimer(30); // Reset the timer
    try {
      const res = await forgetPassword(email);
      if (res?.success) {
        alert("Email resent successfully!", "msg");
      } else {
        alert("Failed to resend email", "error");
      }
    } catch (err) {
      console.error("Error in handleResendCode:", err);
      alert("An error occurred while resending the email", "error");
    }
  };

  // Timer countdown
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer]);

  return (
    <div
      onKeyDown={(e) => {
        if (e.key === "Enter") handleVerify();
      }}
      className="reset-password-otp-main-container flex-center"
    >
      <div className="login-content">
        <svgs.logos.Logo className="logo" />
        <div className="input-wrapper">
          {/* <h3 className="headline">{getText("forgot_password")}</h3> */}
          <p className="text">{getText("otp_code")}</p>
          <div className="otp-inputs">
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderInput={(props) => <input {...props} />}
              shouldAutoFocus={true}
              inputStyle={{
                width: "14%",
                maxWidth: "3.8rem",
                aspectRatio: "1/1",
                borderRadius: "10px",
                borderWidth: "0.5px",
                // margin: "0 5px",
              }}
              containerStyle={{
                justifyContent: "space-between",
                gap: "1rem",
              }}
              placeholder={"000000"}
            />
          </div>
          {error && <div className="error-message">{error}</div>}
        </div>

        <Button
          className="verify-button"
          onClick={handleVerify}
          disabled={loading}
        >
          {loading ? "Verifying..." : getText("verfiy")}
        </Button>

        <div className="footer-row">
          <div className="timer">
            {timer > 0 ? (
              <span>{`Resend code in ${timer}s`}</span>
            ) : (
              <button onClick={handleResendCode}>Resend Code</button>
            )}
          </div>
          <button onClick={() => navigate("/")} className="back-to-login">
            {getText("back_to_login")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordOTP;
